import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { QrScannerModalService } from './qr-scanner-modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
* Modal Component
*/
let QrScannerModalComponent = class QrScannerModalComponent {
    constructor(qrScannerService, sanitizer, themeService) {
        this.qrScannerService = qrScannerService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.enableScanner = false;
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        if (typeof this.data !== 'undefined' && this.data != null) {
            this.enableScanner = this.data.enableScanner;
        }
    }
    scanDone($event) {
        this.qrScannerService.scanDone($event);
        this.close();
    }
    close() {
        this.modal.destroy();
    }
};
QrScannerModalComponent.ctorParameters = () => [
    { type: QrScannerModalService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
QrScannerModalComponent = __decorate([
    Component({
        selector: 'ecd-qr-scanner',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./qr-scanner-modal.component.html")).default
    })
], QrScannerModalComponent);
export { QrScannerModalComponent };
